'use strict';

angular.module('programme')

.directive('kit', function ()
{
    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'modules/programme/editor-components/kit/kit.html',
        controller: 'KitCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('KitCtrl', function ($scope)
{
    $scope.data.image = $scope.data.image || [{type: 'image'}];
    $scope.data.class = $scope.data.class || 'default';
    $scope.data.content = $scope.data.content || {
            title: '1972',
            content: 'Ream madrid',
        };

    $scope.defaultKit = {
        image: [{type: 'image'}],
        content: {
            title: '1972',
            content: 'Ream madrid',
        }
    };

    $scope.data.list = $scope.data.list || [angular.copy($scope.defaultKit)];


    $scope.addKit = function()
    {
        $scope.data.list.push(angular.copy($scope.defaultKit));
    };

    $scope.deleteKit = function(kit)
    {
        var index = $scope.data.list.indexOf(kit);
        if (index === -1) {
            return;
        }

        $scope.data.list.splice(index, 1);
    };
});
